<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2025-12-30 11:36:44
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolNClock.vue
-->
<!--数字时钟-->

<template>
  <div class="tool-nclock ellipsis-1" :class="{ 'multi-line': !media.ext_val_singleLine }" :style="eleStyle">
    <span v-show="media.ext_val_showDate">{{ times.date }}</span>
    <span v-show="media.ext_val_showLunar" v-if="isShowLunar">{{ times.lunar }}</span>
    <span v-show="media.ext_val_showTime">{{ times.time }}</span>
    <span v-show="media.ext_val_showWeek">{{ times.week }}</span>
  </div>
</template>

<script>
import lunarCalendar from "@/assets/scripts/lunarCalendar";
import { getZoneTime, formatting } from "@/assets/scripts/dateFormatting";

export default {
  name: "ToolNClock",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      times: {
        date: 0,
        time: 0,
        week: 0,
        lunar: '农历',
      },
      isShowLunar: this.$cookies.get("language") === 'zh'
    }
  },
  mounted() {
    this.getTime();
    // console.log(LunarCalendar.solarToLunar(2021, 8, 5));
  },
  methods: {
    getTime() {
      let flushTime = () => {
        let date = getZoneTime(this.media.ext_val_tzCount);
        // let year = formatting(date.getFullYear());
        // let month = formatting(date.getMonth() + 1);
        // let day = formatting(date.getDate());
        // this.times.date = `${year}/${month}/${day}`;
        this.fdata(this.media.ext_val_dateStyle, date)
        this.times.time = date.toLocaleTimeString('chinese', { hour12: false });
        if (this.$cookies.get("language") === 'zh') {
          this.times.week = this.$t('PE.Week') + ['日', '一', '二', '三', '四', '五', '六'][date.getDay()];
        } else {
          this.times.week = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][date.getDay()];
        }
        requestAnimationFrame(flushTime);
      }
      requestAnimationFrame(flushTime);
    },
    fdata(dateStyle, date) {
      let year = formatting(date.getFullYear());
      let month = formatting(date.getMonth() + 1);
      let day = formatting(date.getDate());
      switch (dateStyle) {
        case 'yyyy/MM/dd': { this.times.date = `${year}/${month}/${day}`; } break;
        case 'yy/MM/dd': { this.times.date = `${date.getYear() - 100}/${month}/${day}`; } break;
        case 'yyyy-MM-dd': { this.times.date = `${year}-${month}-${day}`; } break;
        case 'yy-MM-dd': { this.times.date = `${date.getYear() - 100}-${month}-${day}`; } break;
        case 'yyyy年MM月dd日': {
          if (this.isShowLunar) {
            this.times.date = `${year}年${month}月${day}日`;
          } else {
            this.times.date = `${year}Year${month}Month${day}Day`;
          }

        } break;
        default: { this.times.date = `${year}/${month}/${day}`; } break;
      }
      let lunar = lunarCalendar.solarToLunar(year, month, day);
      this.times.lunar = `${lunar.GanZhiYear}${lunar.zodiac}[年]${lunar.lunarMonthName}${lunar.lunarDayName}`;
      // :style="`font-size:${media.ext_val_textSize}; font-family:${media.ext_val_family}; `"},
    }
  },
  computed: {
    eleStyle() {
      return {
        'font-size': this.media.ext_val_textSize * 1 * this.ratio + 'px',
        'font-family': this.media.ext_val_family,
        'background': this.media.ext_val_backgroundColor,
        'color': this.media.ext_val_textColor
      }
    },
    ratio() {
      return this.$store.state.program.ratio;
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-nclock {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  user-select: none;
}

.multi-line {
  flex-direction: column;
}
</style>